<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1400px] mx-auto">

    <!-- ============ HERO ============ -->
    <div class="relative overflow-hidden rounded-3xl bg-neutral-900 text-white px-6 sm:px-8 py-7 mb-6 shadow-lg">
      <div class="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-amber-400/20 blur-3xl"></div>
      <div class="pointer-events-none absolute right-10 bottom-0 opacity-[0.07]"><mat-icon class="!text-[160px] !h-[160px] !w-[160px]">badge</mat-icon></div>

      <div class="relative flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div class="max-w-xl">
          <div class="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">admin_panel_settings</mat-icon> Admin
          </div>
          <h1 class="mt-2 text-3xl font-bold tracking-tight">Staff</h1>
          <p class="mt-2 text-sm text-white/60 leading-relaxed">Everyone who works here, with the roles that decide what they can see and do.</p>
        </div>
        <button type="button"
          class="group self-start lg:self-auto flex items-center gap-2.5 pl-2.5 pr-5 py-2.5 rounded-2xl bg-amber-400 text-neutral-900 font-bold text-sm shadow-lg shadow-amber-500/20 hover:bg-amber-300 hover:-translate-y-0.5 active:translate-y-0 transition-all focus:outline-none focus:ring-4 focus:ring-amber-400/40"
          (click)="onCreate()">
          <span class="h-8 w-8 rounded-xl bg-neutral-900 text-amber-400 flex items-center justify-center transition-transform duration-200 group-hover:rotate-90">
            <mat-icon class="!text-[20px] !h-5 !w-5">person_add</mat-icon>
          </span>
          New staff member
        </button>
      </div>

      <div class="relative mt-7 grid grid-cols-2 lg:grid-cols-4 gap-3">
        <button type="button" class="text-left rounded-2xl border px-4 py-3 transition-colors" (click)="statusFilter = 'ACTIVE'"
          [ngClass]="statusFilter === 'ACTIVE' ? 'bg-emerald-400/15 border-emerald-400/50' : 'bg-white/[0.06] border-white/10 hover:bg-white/[0.1]'">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-emerald-300"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">how_to_reg</mat-icon>Active</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : counts.active }}</div>
        </button>
        <div class="rounded-2xl bg-white/[0.06] border border-white/10 px-4 py-3">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-amber-300"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">shield_person</mat-icon>Admins</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : counts.admins }}</div>
        </div>
        <div class="rounded-2xl bg-white/[0.06] border border-white/10 px-4 py-3" matTooltip="People a super admin narrowed to chosen pages">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-sky-300"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">rule</mat-icon>Limited access</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : counts.limited }}</div>
        </div>
        <button type="button" class="text-left rounded-2xl border px-4 py-3 transition-colors" (click)="statusFilter = 'INACTIVE'"
          [ngClass]="statusFilter === 'INACTIVE' ? 'bg-white/[0.14] border-white/30' : 'bg-white/[0.06] border-white/10 hover:bg-white/[0.1]'">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/50"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">person_off</mat-icon>Inactive</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : counts.inactive }}</div>
        </button>
      </div>
    </div>

    <!-- ============ TOOLBAR ============ -->
    <div class="sticky top-0 z-20 -mx-4 sm:mx-0 px-4 sm:px-0 py-3 mb-4 bg-gray-50/90 backdrop-blur">
      <div class="flex flex-col lg:flex-row lg:items-center gap-2.5">
        <div class="relative flex-1 min-w-0">
          <mat-icon class="absolute left-3.5 top-1/2 -translate-y-1/2 !text-gray-400 !text-[20px] !h-5 !w-5 pointer-events-none">search</mat-icon>
          <input type="text" placeholder="Search by name or email…"
            class="w-full pl-11 pr-10 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
            [(ngModel)]="search" />
          @if (search) {
          <button class="absolute right-2.5 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center" (click)="search = ''" aria-label="Clear search">
            <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
          </button>
          }
        </div>
        <div class="flex bg-white border border-gray-200 rounded-xl p-1 gap-1 shadow-sm self-start">
          @for (s of [['ALL', 'Everyone'], ['ACTIVE', 'Active'], ['INACTIVE', 'Inactive']]; track s[0]) {
          <button class="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-all"
            [ngClass]="statusFilter === s[0] ? 'bg-neutral-900 text-white shadow-sm' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'" (click)="statusFilter = $any(s[0])">
            {{ s[1] }} <span class="tabular-nums" [ngClass]="statusFilter === s[0] ? 'text-amber-400' : 'text-gray-400'">{{ statusCount($any(s[0])) }}</span>
          </button>
          }
        </div>
      </div>
      <div class="mt-2.5 flex flex-wrap items-center gap-2">
        <div class="flex flex-wrap bg-white border border-gray-200 rounded-xl p-1 gap-1 shadow-sm">
          <button class="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-all" [ngClass]="roleFilter === 'ALL' ? 'bg-neutral-900 text-white shadow-sm' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'" (click)="roleFilter = 'ALL'">
            All roles <span class="tabular-nums" [ngClass]="roleFilter === 'ALL' ? 'text-amber-400' : 'text-gray-400'">{{ countFor('ALL') }}</span>
          </button>
          @for (r of roleOptions; track r.value) {
          <button class="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-all" [ngClass]="roleFilter === r.value ? 'bg-neutral-900 text-white shadow-sm' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'" (click)="roleFilter = r.value">
            <span class="h-2 w-2 rounded-full" [ngClass]="badge(r.value)"></span>{{ r.label }}
            <span class="tabular-nums" [ngClass]="roleFilter === r.value ? 'text-amber-400' : 'text-gray-400'">{{ countFor(r.value) }}</span>
          </button>
          }
        </div>
        <span class="ml-auto text-xs text-gray-400">{{ loading ? 'Loading…' : visible.length + ' ' + (visible.length === 1 ? 'person' : 'people') }}</span>
      </div>
    </div>

    @if (loadError) {
      <div class="mb-4 bg-red-50 border border-red-200 text-red-700 rounded-2xl p-4 text-sm flex items-center justify-between">
        <span class="flex items-center gap-2"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">cloud_off</mat-icon>Could not load staff.</span>
        <button class="text-xs uppercase font-semibold underline" (click)="load()">Try again</button>
      </div>
    }

    <!-- ============ LIST ============ -->
    @if (loading) {
      <div class="flex flex-col gap-2.5">
        @for (i of [1, 2, 3, 4]; track i) {
        <div class="flex items-center gap-4 rounded-2xl bg-white border border-gray-100 px-5 py-4 animate-pulse">
          <div class="h-11 w-11 rounded-full bg-gray-100"></div>
          <div class="flex-1"><div class="h-4 w-1/4 rounded bg-gray-100"></div><div class="mt-2 h-3 w-1/3 rounded bg-gray-100"></div></div>
          <div class="hidden md:flex gap-1.5"><div class="h-6 w-20 rounded-md bg-gray-100"></div><div class="h-6 w-16 rounded-md bg-gray-100"></div></div>
        </div>
        }
      </div>
    } @else if (visible.length === 0) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">No staff match</p>
        <button class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="search = ''; roleFilter = 'ALL'; statusFilter = 'ALL'">Clear filters</button>
      </div>
    } @else {
      <div class="flex flex-col gap-2.5">
        @for (m of visible; track m.userid) {
        <div role="button" tabindex="0" (click)="view(m)" (keydown.enter)="view(m)"
          class="group grid grid-cols-[auto_minmax(0,1fr)_auto] lg:grid-cols-[auto_minmax(0,1.2fr)_minmax(0,1.4fr)_120px_auto] gap-x-4 gap-y-3 items-center rounded-2xl bg-white border px-4 sm:px-5 py-3.5 cursor-pointer transition-all duration-200 hover:-translate-y-px hover:shadow-[0_8px_24px_-12px_rgba(0,0,0,0.18)] focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-100"
          [ngClass]="[selected?.userid === m.userid ? 'border-amber-300 ring-4 ring-amber-100/80' : 'border-gray-100 hover:border-gray-200', m.isActive ? '' : 'opacity-60']">

          <span class="relative h-11 w-11 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0"
            [ngClass]="m.roles.includes('S-ADMIN') ? 'bg-neutral-900 text-amber-400' : 'bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900'">
            {{ initials(m) }}
            <span class="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full ring-2 ring-white" [ngClass]="m.isActive ? 'bg-emerald-500' : 'bg-gray-400'"></span>
          </span>

          <div class="min-w-0">
            <div class="text-[15px] font-semibold text-gray-900 truncate">{{ m.firstname }} {{ m.lastname }}</div>
            <div class="text-xs text-gray-400 truncate">{{ m.useremail }}</div>
          </div>

          <!-- Actions (top right on phones) -->
          <div class="lg:order-last flex items-center gap-0.5 rounded-xl bg-gray-50 border border-gray-100 p-0.5 lg:opacity-0 lg:group-hover:opacity-100 lg:group-focus-within:opacity-100 transition-opacity" [class.lg:opacity-100]="selected?.userid === m.userid">
            <button class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" (click)="$event.stopPropagation(); view(m)" matTooltip="View" aria-label="View"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">visibility</mat-icon></button>
            <button class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" (click)="$event.stopPropagation(); onEdit(m)" matTooltip="Edit" aria-label="Edit"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">edit</mat-icon></button>
          </div>

          <!-- Roles -->
          <div class="col-span-3 lg:col-span-1 flex flex-wrap gap-1">
            @for (r of m.roles; track r) {
              <span class="text-[11px] font-semibold px-2 py-0.5 rounded-md" [ngClass]="badge(r)">{{ label(r) }}</span>
            }
            @if (m.allowedPages) {
              <span class="text-[11px] font-semibold px-2 py-0.5 rounded-md bg-sky-50 text-sky-700 border border-sky-100" matTooltip="A super admin limited this person to chosen pages">{{ m.allowedPages.length }} pages only</span>
            }
          </div>

          <!-- Status -->
          <div class="col-span-3 lg:col-span-1">
            <span class="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-lg" [ngClass]="m.isActive ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-500'">
              <span class="h-1.5 w-1.5 rounded-full" [ngClass]="m.isActive ? 'bg-emerald-500' : 'bg-gray-400'"></span>{{ m.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
        }
      </div>
    }
  </div>
  </div>

  <!-- ============ VIEW (slide-over) ============ -->
  @if (selected; as m) {
  <div class="fixed inset-0 z-40 bg-black/30 backdrop-blur-[1px] sf-fade" (click)="selected = null"></div>
  <aside class="fixed inset-y-0 right-0 z-50 w-full max-w-md bg-white shadow-2xl flex flex-col sf-slide" role="dialog" aria-modal="true" aria-label="Staff member">
    <div class="flex-1 overflow-y-auto">
      <div class="relative overflow-hidden bg-neutral-900 text-white px-6 pt-6 pb-5">
        <div class="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-amber-400/20 blur-2xl"></div>
        <div class="relative flex items-start justify-between gap-3">
          <div class="flex items-center gap-3 min-w-0">
            <span class="h-14 w-14 rounded-full bg-amber-400 text-neutral-900 text-lg font-bold flex items-center justify-center flex-shrink-0">{{ initials(m) }}</span>
            <div class="min-w-0">
              <div class="text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">Staff member</div>
              <div class="text-xl font-bold leading-tight truncate">{{ m.firstname }} {{ m.lastname }}</div>
              <a class="text-sm text-white/60 hover:text-white truncate block" [href]="'mailto:' + m.useremail">{{ m.useremail }}</a>
            </div>
          </div>
          <button type="button" class="h-9 w-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0" (click)="selected = null" aria-label="Close"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon></button>
        </div>
        <div class="relative mt-4 flex flex-wrap items-center gap-2">
          <span class="text-[11px] font-bold px-2 py-0.5 rounded-md" [ngClass]="m.isActive ? 'bg-emerald-400/20 text-emerald-200' : 'bg-white/10 text-white/60'">{{ m.isActive ? 'Active - can sign in' : 'Inactive - can\'t sign in' }}</span>
          <span class="text-[11px] font-bold px-2 py-0.5 rounded-md bg-white/10 text-white/80">{{ accessCount(m) }} pages</span>
        </div>
        <div class="relative mt-4">
          <button type="button" class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-amber-400 text-neutral-900 text-xs font-bold hover:bg-amber-300" (click)="onEdit(m)"><mat-icon class="!text-[16px] !h-4 !w-4">edit</mat-icon>Edit access</button>
        </div>
      </div>

      <div class="p-6 flex flex-col gap-6">
        <div>
          <div class="text-[11px] font-bold uppercase tracking-wider text-gray-500 mb-2">Roles</div>
          <div class="flex flex-col gap-2">
            @for (r of m.roles; track r) {
              <div class="flex items-start gap-3 rounded-xl border border-gray-100 px-3.5 py-2.5">
                <span class="mt-0.5 text-[11px] font-bold px-2 py-0.5 rounded-md flex-shrink-0" [ngClass]="badge(r)">{{ label(r) }}</span>
                <span class="text-xs text-gray-500 leading-snug">{{ roleInfo(r)?.description }}</span>
              </div>
            }
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between mb-2">
            <span class="text-[11px] font-bold uppercase tracking-wider text-gray-500">Pages they can open</span>
            @if (m.allowedPages) { <span class="text-[11px] font-semibold text-sky-700">Narrowed by a super admin</span> }
            @else { <span class="text-[11px] text-gray-400">Everything their roles allow</span> }
          </div>
          @if (m.roles.includes('S-ADMIN')) {
            <div class="rounded-xl bg-neutral-900 text-amber-400 px-4 py-3 text-sm font-semibold flex items-center gap-2"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">all_inclusive</mat-icon>Every page</div>
          } @else {
            <div class="flex flex-col gap-3">
              @for (g of accessGroups(m); track g.name) {
                <div>
                  <div class="text-xs font-semibold text-gray-700 mb-1.5">{{ g.name }}</div>
                  <div class="flex flex-wrap gap-1.5">
                    @for (p of g.pages; track p) { <span class="text-xs px-2.5 py-1 rounded-lg bg-gray-100 text-gray-700">{{ p }}</span> }
                  </div>
                </div>
              } @empty {
                <div class="rounded-xl bg-gray-50 py-5 text-center text-sm text-gray-400">No pages</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </aside>
  }
</app-main-layout>
